import React from 'react'
import Accordion from '../../../accordion-v2/accordion'
import { Less } from '../../../../svg/less'
import { More } from '../../../../svg/more'

const dataFaq = [
  {
    title:
      '¿Quiénes pueden aportar a su fondo de pensiones desde Yape? ¿Puede alguien más aportar a mi fondo desde Yape?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        Esta opción está disponible para todos los afiliados de Prima AFP, lo
        que significa que no importa si eres trabajador independiente,
        comerciante, profesional o estudiante (mayor de 18 años) que no aporta
        regularmente a su jubilación. Además, si eres cliente de Yape, puedes
        realizar aportes a cualquier afiliado de Prima AFP, ya sea tu propio
        fondo de jubilación o el de un familiar o amigo que también sea
        afiliado.
      </div>
    ),
  },
  {
    title:
      '¿Cuál es el monto mínimo y máximo que puedo aportar a mi fondo de pensiones desde Yape? ¿Cuántas veces puedo aportar en el mes?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        El monto mínimo de aporte es de S/146.56, calculado sobre la base de la
        Remuneración Mínima Vital actual e incluye la prima de seguro y
        comisión, si corresponde. No hay un límite máximo de aportes, pero
        existen límites diarios y mensuales para las transacciones: hasta
        S/2,000 diarios y un tope de S/6,000 al mes. La frecuencia de los
        aportes la eliges tú, muchos afiliados optan por realizar un aporte al
        mes.
      </div>
    ),
  },
  {
    title:
      'En caso de aportar a través de Yape el mínimo establecido, ¿el total de este monto va directo a mi fondo?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        El monto mínimo establecido de S/146.56 o cualquier pago superior a ese
        monto que se realice a través de Yape, es distribuido conforme lo indica
        la norma; cuando recibimos el aporte lo primero que hacemos es calcular
        la remuneración del cliente y sobre esa base efectuamos la distribución
        normada del pago: fondo de pensiones, prima de seguro que protege al
        afiliado en caso de invalidez o fallecimiento y la comisión de la AFP,
        en caso corresponda.
      </div>
    ),
  },
  {
    title: '¿Por qué me cobran una prima de seguro?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        La prima de seguro es esencial porque te brinda protección en caso de
        invalidez debido a un accidente o garantiza una pensión de sobrevivencia
        para tus beneficiarios en caso de tu fallecimiento. Para tener esta
        cobertura, es necesario que hayas realizado o recibido cuatro aportes
        dentro de los ocho meses calendario anteriores al mes en que ocurra el
        accidente o fallecimiento.
      </div>
    ),
  },
  {
    title:
      '¿En qué momento se le informa al afiliado cuál es la comisión que está pagando?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        Luego de completar el pago a través de Yape, recibirás un correo
        electrónico el cuarto día hábil que detalla cómo se distribuye tu aporte
        y el tipo de comisión que pagas, si es aplicable. En esta comunicación
        también se indica el tipo de comisión que pagas, en conformidad con las
        regulaciones de la Ley 29903 y la Resolución SBS N° 8514-2012.
      </div>
    ),
  },
  {
    title: '¿Por qué esta opción se enfoca en los trabajadores independientes?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        Este canal de pago está diseñado para alcanzar a todos los afiliados que
        no aportan regularmente para su jubilación: trabajadores independientes
        que no tienen empleo formal, comerciantes, profesionales, estudiantes
        mayores de 18 años, entre otros. Lo que se busca con esta alternativa es
        acercarnos más a ese 70% de trabajadores peruanos que hoy labora en un
        entorno de informalidad.
      </div>
    ),
  },
  {
    title: '¿Hay posibilidad de que el aporte realizado desde Yape rebote?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        <div className={`tw-mb-2`}>Las consecuencias inmediatas son:</div>
        No hay posibilidad que el pago rebote.
      </div>
    ),
  },
  {
    title:
      '¿El aporte a mi fondo desde Yape solo es válido si estoy afiliado a Prima AFP?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        Los aportes a través de Yape solo se pueden hacer a los fondos de los
        afiliados de Prima AFP. Si intentas realizar un aporte a una persona que
        no esté afiliada a Prima AFP, recibirás un mensaje de que el cliente no
        se encontró. Sin embargo, los usuarios de Yape, independientemente de su
        AFP, pueden aportar a cualquier afiliado de Prima AFP.
      </div>
    ),
  },
  {
    title:
      'Si tengo Plin, ¿puedo Yapear desde mi Plin a mi fondo de pensiones?',
    content: (
      <div className={`font-family-primary c-gray--4 fw-4 tw-f-16`}>
        No, esta modalidad de aporte solo se puede realizar a través de Yape en
        este momento.
      </div>
    ),
  },
]

const ResolvemosTusDudas = () => {
  return (
    <>
      <div className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mt-0 center w-60@lg ml-auto mr-auto tw-mb-4 tw-mb-4@lg ">
        Aportes independientes por Yape
      </div>

      <h2 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg center tw-mb-12 tw-mb-12@lg tw-mt-0">
        Resolvemos tus dudas
      </h2>

      <div className={``}>
        {dataFaq.map(({ title, content }) => (
          <Accordion
            title={title}
            content={content}
            icoOpen={Less}
            icoClose={More}
            titleColorOpen={true}
            borderBottom={true}
            key={title}
            GTMSection="tipos de aporte"
            GTMSubSection="Resolvemos tus dudas"
            GTMLink="/aportes-y-fondo/tipos-de-aportes/independientes-por-yape"
          />
        ))}
      </div>
    </>
  )
}

export default ResolvemosTusDudas
